import { categories } from '../api'
import blog from '../blog'
import prognostic from '../prognostics'
import search from '../search'

const select = {
  variables: {
    searchInput: ''
  },

  elements: {
    wrapper: document.querySelector('.SelectPost'),
    titleContainer: document.querySelector('.SelectPost-title'),
    title: document.querySelector('.SelectPost-title span'),
    container: document.querySelector('.SelectPost-menu'),
    catContainer: document.querySelector('#categoryShow'),
    typePostAuthor: document.querySelector('#typePostOnAuthor'),
  },

  markup: ({ data, active }) => {
    if (select.elements.typePostAuthor) {
      const slugPaplpites = select.elements.typePostAuthor.getAttribute('data-urlslug-palpites');
      const slugConteudo = select.elements.typePostAuthor.getAttribute('data-urlslug-posts');

      return data
      .map(
        item =>
        `<div
          class="SelectPost-item ${active === item.id ? 'active' : ''}"
          data-id="${item}"
        >
          ${item === "palpites" ? slugPaplpites : slugConteudo}
        </div>`
      )
      .join('')

    }
    return data
      .map(
        item =>
        `<div
          class="SelectPost-item ${active === item.id ? 'active' : ''}"
          data-id="${item.id}"
        >
          ${item.parent !== 0 ? `— ${item.name}` : item.name}
        </div>`
      )
      .join('')
  },

  handleClickSelect: ({ layout, items }) => {
    if (select.elements.titleContainer && items.length > 3) {
      select.elements.titleContainer.addEventListener('click', () => {
        const wrapper = select.elements.wrapper
        let buttonClass = '';

        if (layout === 'blog') {
          buttonClass = '.CardPostWrapper-btn';
        } else if (layout === 'prognostico') {
          buttonClass = '.CardPrognosticWrapper-btn';
        } else {
          buttonClass = '.CardSearchWrapper-btn';
        }
        const button = document.querySelector(buttonClass)

        if (wrapper.classList.contains('active') && button) {
          wrapper.classList.remove('active')
          return
        } else {
          wrapper.classList.add('active')
        }
      })
    }

  },

  handleClickItem: ({ items, perPage, author, layout }) => {
    let buttonClass = '';
    if (layout === 'blog') {
      buttonClass = '.CardPostWrapper-btn';
    } else if (layout === 'prognostico') {
      buttonClass = '.CardPrognosticWrapper-btn';
    } else {
      buttonClass = '.CardSearchWrapper-btn';
    }

    Array.from({ length: items.length }, (_, i) => {
      items[i].addEventListener('click', el => {
        const wrapper = select.elements.wrapper
        const target = el.target
        const idSelect = target.dataset.id
        const current = document.getElementsByClassName('SelectPost-item active')

        if (!(target instanceof HTMLInputElement) && idSelect) {
          current[0].className = current[0].className.replace(' active', '')
          target.className += ' active'
          select.elements.title.innerHTML = target.textContent.replace('—', '')
        }

        if (wrapper.classList.contains('active') && !(target instanceof HTMLInputElement) && idSelect) {
          wrapper.classList.remove('active')
        }

        if (idSelect) {
          const button = document.querySelector(buttonClass)
          button.style.display = 'inline-flex'
          if (layout === 'blog') {
            blog.init({ id: idSelect, perPage, author, offset: 0, forceLoad: true })
          } else if (layout === 'prognostico') {
            prognostic.init({ id: idSelect, perPage, offset: 0, forceLoad: true })
          } else {
            search.init({ id: idSelect, perPage, offset: 0 })
          }
        }
      })
    })
  },

  handleSearch: ({ id, perPage, layout, idList, typePost, titleDefault }) => {
    const search = document.querySelector('#searchSelect')
    const doneTypingInterval = 1000;
    var typingTimer;

    search.addEventListener('keyup', () => {
      clearTimeout(typingTimer);
      select.variables.searchInput = search.value;
      typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    function doneTyping() {
      select.searchInit({ id, perPage, layout, idList, typePost, titleDefault, filter:`&search=${select.variables.searchInput}` })
    }
  },

  init: async ({ id, perPage, typePost, author, layout, filter, wrapper }) => {
    select.elements.wrapper        = document.querySelector(wrapper + ' .SelectPost')
    select.elements.titleContainer = document.querySelector(wrapper + ' .SelectPost-title')
    select.elements.title          = document.querySelector(wrapper + ' .SelectPost-title span')
    select.elements.container      = document.querySelector(wrapper + ' .SelectPost-menu')

    const typePostAuthor = select.elements.typePostAuthor
    const title = select.elements.title
    const container = select.elements.container

    if ( ! select.elements.titleContainer ) {
      return;
    }

    let titleSelect = select.elements.titleContainer.getAttribute('titleText')
    const titleDefault = titleSelect;

    const idList = document.querySelector('#listSelectionPostBlock')
      ? document.querySelector('#listSelectionPostBlock')
      : document.querySelector('#listSelectionPrognosticBlock')

    const data = await categories({ id: idList ? idList.value : 0, postType: typePost, filter })
    const catContainer = select.elements.catContainer
    let catName = ''

    if(catContainer) {
      catName = catContainer.dataset.name || ''
    }

    if (select.elements.wrapper) {
      select.elements.wrapper.classList.remove('loading')
    }

    if (data.length === 1) {
      titleSelect = data[0].name
    }

    if (title) {
      title.innerHTML = catName || titleSelect
    }

    if (container) {
      if (typePostAuthor) {
        const value = typePostAuthor && typePostAuthor.value;
        const valueArray = value.split(', ');

        container.innerHTML = `
      <div class="SelectPost-item search-input">
        <input class="search" value="${select.variables.searchInput}" id="searchSelect" placeholder="` + clubei18n.pesquisar + `" />
        <button type="button" id="searchButton">
          <svg
            class="searchIcon"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="-1 0 136 136.21852"
            height="13px"
            width="13px"
          >
            <g id="surface1">
            <path d="M 93.148438 80.832031 C
                109.5 57.742188 104.03125 25.769531 80.941406 9.421875 C 57.851562 -6.925781
                25.878906 -1.460938 9.53125 21.632812 C -6.816406 44.722656 -1.351562 76.691406
                21.742188 93.039062 C 38.222656 104.707031 60.011719 105.605469 77.394531 95.339844 L
                115.164062 132.882812 C 119.242188 137.175781 126.027344 137.347656 130.320312
                133.269531 C 134.613281 129.195312 134.785156 122.410156 130.710938 118.117188 C
                130.582031 117.980469 130.457031 117.855469 130.320312 117.726562 Z M 51.308594
                84.332031 C 33.0625 84.335938 18.269531 69.554688 18.257812 51.308594 C 18.253906
                33.0625 33.035156 18.269531 51.285156 18.261719 C 69.507812 18.253906 84.292969
                33.011719 84.328125 51.234375 C 84.359375 69.484375 69.585938 84.300781 51.332031
                84.332031 C 51.324219 84.332031 51.320312 84.332031 51.308594 84.332031 Z M
                51.308594 84.332031 "
              style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" />
            </g>
          </svg>
        </button>
      </div>
      <div class="SelectPost-item ${id === 0 ? 'active' : ''}" data-id="0">${titleDefault}</div>
      ${select.markup({ data: valueArray, active: id })}
    `
      } else {
      container.innerHTML = `
      <div class="SelectPost-item search-input">
        <input class="search" value="${select.variables.searchInput}" id="searchSelect" placeholder="` + clubei18n.pesquisar + `" />
        <button type="button" id="searchButton">
          <svg
            class="searchIcon"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="-1 0 136 136.21852"
            height="13px"
            width="13px"
          >
            <g id="surface1">
            <path d="M 93.148438 80.832031 C
                109.5 57.742188 104.03125 25.769531 80.941406 9.421875 C 57.851562 -6.925781
                25.878906 -1.460938 9.53125 21.632812 C -6.816406 44.722656 -1.351562 76.691406
                21.742188 93.039062 C 38.222656 104.707031 60.011719 105.605469 77.394531 95.339844 L
                115.164062 132.882812 C 119.242188 137.175781 126.027344 137.347656 130.320312
                133.269531 C 134.613281 129.195312 134.785156 122.410156 130.710938 118.117188 C
                130.582031 117.980469 130.457031 117.855469 130.320312 117.726562 Z M 51.308594
                84.332031 C 33.0625 84.335938 18.269531 69.554688 18.257812 51.308594 C 18.253906
                33.0625 33.035156 18.269531 51.285156 18.261719 C 69.507812 18.253906 84.292969
                33.011719 84.328125 51.234375 C 84.359375 69.484375 69.585938 84.300781 51.332031
                84.332031 C 51.324219 84.332031 51.320312 84.332031 51.308594 84.332031 Z M
                51.308594 84.332031 "
              style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" />
            </g>
          </svg>
        </button>
      </div>
      <div class="SelectPost-item ${id === 0 ? 'active' : ''}" data-id="0">${titleDefault}</div>
      ${select.markup({ data, active: id })}
    `}
    }

    const items = document.querySelectorAll('.SelectPost-item')
    select.handleClickSelect({ layout, items })
    select.handleClickItem({ items, perPage, author, layout })
    select.handleSearch({ id, perPage, layout, idList, typePost, titleDefault })
  },

  searchInit: async ({ id, perPage, layout, idList, typePost, titleDefault, filter }) => {
    const container = select.elements.container;

    const data = await categories({ id: idList ? idList.value : 0, postType: typePost, filter })

    if (container) {
      container.innerHTML = `
      <div class="SelectPost-item search-input">
        <input class="search" value="${select.variables.searchInput}" id="searchSelect" placeholder="` + clubei18n.pesquisar + `" />
        <button type="button" id="searchButton">
          <svg
            class="searchIcon"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="-1 0 136 136.21852"
            height="13px"
            width="13px"
          >
            <g id="surface1">
            <path d="M 93.148438 80.832031 C
                109.5 57.742188 104.03125 25.769531 80.941406 9.421875 C 57.851562 -6.925781
                25.878906 -1.460938 9.53125 21.632812 C -6.816406 44.722656 -1.351562 76.691406
                21.742188 93.039062 C 38.222656 104.707031 60.011719 105.605469 77.394531 95.339844 L
                115.164062 132.882812 C 119.242188 137.175781 126.027344 137.347656 130.320312
                133.269531 C 134.613281 129.195312 134.785156 122.410156 130.710938 118.117188 C
                130.582031 117.980469 130.457031 117.855469 130.320312 117.726562 Z M 51.308594
                84.332031 C 33.0625 84.335938 18.269531 69.554688 18.257812 51.308594 C 18.253906
                33.0625 33.035156 18.269531 51.285156 18.261719 C 69.507812 18.253906 84.292969
                33.011719 84.328125 51.234375 C 84.359375 69.484375 69.585938 84.300781 51.332031
                84.332031 C 51.324219 84.332031 51.320312 84.332031 51.308594 84.332031 Z M
                51.308594 84.332031 "
              style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" />
            </g>
          </svg>
        </button>
      </div>
      <div class="SelectPost-item ${id === 0 ? 'active' : ''}" data-id="0">${titleDefault}</div>
      ${select.markup({ data, active: id })}
    `
    }

    const items = document.querySelectorAll('.SelectPost-item')
    select.handleSearch({ id, perPage, layout, idList, typePost, titleDefault })
    select.handleClickItem({ items, perPage, layout })
  }
}

export default select
